var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Attribute",
      prop: "attribute"
    }
  }, [_c("el-tree", {
    ref: "tree",
    attrs: {
      data: _vm.attributes,
      "check-on-click-node": true,
      "show-checkbox": "",
      "node-key": "id",
      "default-checked-keys": _vm.selectedAttributes,
      "empty-text": "No Attributes",
      props: {
        label: "name"
      }
    },
    on: {
      "check-change": _vm.emitFormData
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };